import { z } from 'zod';

export const JOB_PICKER_PAGE_SIZE = 25;
export const JOB_PICKER_TITLE_MAX = 200;
export const JOB_PICKER_SEARCH_MAX = 120;
export const JOB_PICKER_CURSOR_MAX = 2048;
export const JOB_PICKER_VIEW = 'marketplace-picker';

export const JobPickerRequestSchema = z.object({
  search: z.string().trim().max(JOB_PICKER_SEARCH_MAX).refine(value => !value.includes('\0')).default(''),
  cursor: z.string().min(1).max(JOB_PICKER_CURSOR_MAX).optional(),
}).strict();
export type JobPickerRequest = z.infer<typeof JobPickerRequestSchema>;

export const JobPickerPageSchema = z.object({
  jobs: z.array(z.object({
    id: z.string().uuid(),
    // PostgreSQL left(text, n) counts Unicode code points, not UTF-16 units.
    title: z.string().min(1).max(JOB_PICKER_TITLE_MAX * 2)
      .refine(value => [...value].length <= JOB_PICKER_TITLE_MAX),
    status: z.enum(['draft', 'active', 'published']),
  }).strict()).max(JOB_PICKER_PAGE_SIZE),
  nextCursor: z.string().min(1).max(JOB_PICKER_CURSOR_MAX).nullable(),
}).strict();
export type JobPickerPage = z.infer<typeof JobPickerPageSchema>;
